var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#Summer_Green);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Summer_Green",
    "data-name": "Summer Green",
    x1: 80.7,
    y1: 512,
    x2: 943.3,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#77c697"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#37bb80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00b36c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00b169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a652"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M917.28,449.17L574.83,106.72c-34.7-34.7-90.96-34.7-125.66,0L106.72,449.17c-34.7,34.7-34.7,90.96,0,125.66l137.59,137.59c48.57-48.53,97.1-97.11,145.61-145.71,19.48-19.52,38.74-39.26,58.09-58.89-13.77-14.43-27.58-28.91-39.87-41.79,50.9-51.62,101.71-103.15,152.32-154.47,50.49,51.08,101.1,102.27,150.83,152.58-50.21,50.29-100.77,100.92-153.03,153.26-12.03-13.89-24.86-28.69-38.62-44.57-11.42,10.79-19.96,18.54-28.13,26.65-60.28,59.76-120.53,119.55-180.72,179.4l138.38,138.38c34.7,34.7,90.96,34.7,125.66,0l342.44-342.44c34.7-34.7,34.7-90.96,0-125.66Zm-538.95-10.82c-7.73-8.53-15.59-16.53-22.66-25.18-8.7-10.62-8.56-26.79,1.76-37.22,38.82-39.24,78.08-78.04,117.53-116.65,8.93-8.74,25.37-9.51,35-1.98,9.45,7.4,17.9,16.08,25.66,23.16-52.75,52.94-104.49,104.87-157.29,157.86Zm385.88,113.55c-38.06,38.73-76.51,77.09-115.41,114.97-11.73,11.42-28.3,10.54-40.73-.66-7.61-6.87-14.21-14.86-20.04-21.05,51.69-51.94,103.05-103.56,155.69-156.46,7.99,8.76,16.35,16.94,23.52,26.04,8.6,10.92,7.92,26.01-3.04,37.16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/AppIcon.cd1fda52f12ef8a1937aea6489350526.svg";
export { ForwardRef as ReactComponent };